module.exports = {
  SET_AUTHENTICATION: 'SET_AUTHENTICATION',
  SET_USER_DETAILS: 'SET_USER_DATA',
}
